// extracted by mini-css-extract-plugin
module.exports = {"tableScrollContainer":"_403x4WS","tableRoot":"DLdUYE6J","tableHeader":"mHLfMdRa","footerRow":"xiDsoiVG","rankWrapper":"w_f7S0G7","sectorName":"SWEDLzV6"};